import { render, staticRenderFns } from "./WattChart.vue?vue&type=template&id=739f8c09&scoped=true"
import script from "./WattChart.vue?vue&type=script&lang=js"
export * from "./WattChart.vue?vue&type=script&lang=js"
import style0 from "./WattChart.vue?vue&type=style&index=0&id=739f8c09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f8c09",
  null
  
)

export default component.exports